angular.module('qkr').controller('ImageController', ($scope, $rootScope, appConfig, $http, utils, imageService,
                                                     $upload, messageService, inputImage) => {
	$scope.cropping = false;
	$scope.form = {};

	$scope.fileUploading = false;
	$scope.fileUploaded = false;
	$scope.selectedFiles = [];
	$scope.progress = [];
	$scope.crop = [];
	$scope.imageUrl = null;
	$scope.contentType = null;
	$scope.pic_real_width = 0;
	$scope.pic_real_height = 0;

	$scope.cancelImage = function() {
		$scope.$close('cancel');

	};

	$scope.cropFile = function() {
		let scale = 1.0;

		if ($scope.pic_real_width > 0) {
			scale = 440 / $scope.pic_real_width;
		}

		$scope.cropping = true;

		const data = {
			crop_x: parseInt($scope.crop.x / scale),
			crop_y: parseInt($scope.crop.y / scale),
			crop_w: parseInt($scope.crop.w / scale),
			crop_h: parseInt($scope.crop.h / scale),
			scale_width_to: $rootScope.scaledWidthAbsolute,
			media_id: $scope.mediaElement.id
		};

		// Some quick dirty validation as the server throws a 500 error if the
		// Crop area is outside the
		// Image bounds - often caused by rounding bugs.
		if (data.crop_w > $scope.pic_real_width)
			data.crop_w = $scope.pic_real_width;

		if (data.crop_h > $scope.pic_real_height)
			data.crop_h = $scope.pic_real_height;

		const responsePostedImage = (data) => {

			$scope.cropping = false;
			$scope.croppedMedia = data.data;
			imageService.newImageUrl = $scope.croppedMedia.mediaValue;

			$scope.$close($scope.croppedMedia);
			$rootScope.$broadcast('imageUploaded');
		};

		const errorHandlerPostedImage = (reason) => {
			messageService.error(reason.data.exception);

			$scope.cropping = false;
			$scope.status = reason.status;
		}

		$http.post(appConfig.apiUrl + 'image/crop', data)
			.then(responsePostedImage, errorHandlerPostedImage);
	};
	// When a file is selected we automatically upload it
	$scope.onFileSelect = function($files) {
		$scope.selectedFiles = $files;
		$scope.fileUploaded = false;
		$scope.fileUploading = true;

		const responseUploadedImage = (data) => {
			$rootScope.$broadcast('clearJCrop');

			$rootScope.$broadcast('initialiseJCrop');

			$('#jcroptarget').load(function () {
				$scope.pic_real_width = this.naturalWidth; // Note: $(this).width()
													// Will not
				$scope.pic_real_height = this.naturalHeight; // Work for in
				// Memory images.
			});

			// Bad practice but a quick fix - want to clear the file
			angular.forEach(angular.element('input[type=\'file\']'), (inputElem) => {
				angular.element(inputElem).val(null);
			});
			$scope.fileUploaded = true;
			$scope.fileUploading = false;

			// Should get the height and width from here

			$scope.mediaElement = data.data;

			// To fix IE not updating the dom
			if (!$scope.$$phase) {
				$scope.$apply();
			}
		};

		const errorHandlerImageUploaded = (reason) => {
			$scope.fileUploading = false;

			// QKRD-3390: Show error message from server
			messageService.errorWithReason(reason.exception, null, true);
			$scope.cancelImage();
		}

		const i = 0; // Only look at first file
		const $file = $files[i];
		$scope.progress[i] = 0;

		(function () {

			$upload.upload({
				url: appConfig.apiUrl + 'image/create',
				data: {
					referenceName: imageService.editingImageReferenceName
				},
				file: $file,
				fileFormDataName: 'myFile',
				method: 'POST'
			}).then(responseUploadedImage, errorHandlerImageUploaded);

		}());
	};

	// Call on page load
	$scope.init = function() {
		$scope.saving = false;

        if (!utils.hasNoValue(inputImage)) {
			$scope.fileUploaded = false;
			$scope.fileUploading = true;
			$scope.onFileSelect(inputImage);
		}
    },

	$scope.cancelEditMenu = function() {
		$scope.saving = false;
		$scope.close();
	};
});

function showCoords(scope, c) {
	scope.crop.x = c.x;
	scope.crop.y = c.y;
	scope.crop.x2 = c.x2;
	scope.crop.y2 = c.y2;
	scope.crop.w = c.w;
	scope.crop.h = c.h;
}



// WEBPACK FOOTER //
// ./src/controllers/modal/image.controller.js